import {DataStatus} from 'platform/components';

import {isNil} from 'ramda';

import {useGetVehicleV2Query} from '@dms/api/sales';
import {VehicleWidget, getBusinessCaseTradeTypeFlag} from '@dms/shared';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

type VehicleOverviewProps = {
  vehicleId: string;
  isBrokerage: boolean;
} & RequiredTestIdProps;

export const VehicleOverview = (props: VehicleOverviewProps) => {
  const {
    data: vehicle,
    isLoading: isLoadingVehicle,
    isError: isVehicleError,
  } = useGetVehicleV2Query({vehicleId: props.vehicleId ?? ''}, {skip: isNil(props.vehicleId)});

  const flag = getBusinessCaseTradeTypeFlag(props.isBrokerage ? 'BROKERAGE' : 'IN_STOCK');

  return (
    <DataStatus isLoading={isLoadingVehicle} isError={isVehicleError}>
      <VehicleWidget
        data-testid={suffixTestId('vehicleOverview', props)}
        key={vehicle?.id}
        vehicle={vehicle!}
        flags={[flag!]}
      />
    </DataStatus>
  );
};
